import { createFileRoute } from '@tanstack/react-router'
import { TradeMiningPage } from '@/features/mining/trade-mining/TradeMiningPage'

export const Route = createFileRoute('/_app/mining/trade')({
  component: TradeMiningPage,
})
